document.addEventListener('click', async function (e) {
  const btn = e.target.closest('[data-tw-remove-bundle]');
  if (!btn) return;

  const bundleId = btn.getAttribute('data-bundle-id');
  if (!bundleId) return;

  btn.disabled = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const keysToRemove = cart.items
      .filter(i => i.properties && i.properties._tw_bundle_id === bundleId)
      .map(i => i.key);

    for (const key of keysToRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    window.location.reload();
  } catch (err) {
    console.error(err);
    btn.disabled = false;
  }
});
